import React from "react"
import { Divider as AntdDivider } from "antd"
import type { DividerProps } from "antd/lib/divider"

export const Divider = (props: DividerProps): JSX.Element => {
  return <AntdDivider {...props} />
}
